export const COLORS = [
  "#0B0D24",
  "#006AFF",
  "#05A797",
  "#141B67",
  "#19021B",
  "#798530",
  "#9D870B",
  "#E0DEE9",
  "#FF1616",
];

export const userDetails = {
  bot_id: "166",
  email: "reenath564@gmail.com",
  entity_id: "34331e8350c1419e3d2a61c763c35db1",
  otp:"282179",
  type: "FILES",
};


export const FR_SDK_FACE_API = process.env.REACT_APP_FR_SDK_FACE_API || "";
export const FR_SDK_KYC_API = process.env.REACT_APP_FR_SDK_KYC_API || "";
